<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑分类` : '新增分类'" width="500" @on-cancel="modalCancel">
    <Row>
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="分类名称" prop="title">
            <Input placeholder="请输入分类名称" v-model="form.title"></Input>
          </FormItem>
          <FormItem label="排序" prop="sort">
            <Input placeholder="请输入排序" v-model="form.sort"></Input>
          </FormItem>
          <FormItem label="状态" prop="status">
            <RadioGroup v-model="form.status">
              <Radio label="1">有效</Radio>
              <Radio label="0">无效</Radio>
            </RadioGroup>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash'
import * as apiArticle from '@/api/article'
export default {
  name: 'add-card',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      form: {
        title: '',
        sort:"",
        status: '1'
      },
      rules: {
        title: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 获取详情
    getDetail () {
      apiArticle.apiArticleCategoryDetail(this.id).then(res => {
        const {title,status,sort} = res.data
        this.form.title = title
        this.form.status = status + ''
        this.form.sort = sort + ''
      })
    },
    // 提交
    modalConfirm () {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          if (this.isEdit) {
            let opt = _.cloneDeep(this.form)
            apiArticle.apiArticleCategoryEdit(this.id,{ ...opt }).then(res => {
              this.$Message.success('编辑成功')
              this.$emit('on-success')
              this.modalCancel()
            })
          } else {
            apiArticle.apiArticleCategoryAdd({ ...this.form }).then(res => {
              this.$Message.success('新增成功')
              this.$emit('on-success')
              this.modalCancel()
            })
          }
        }
      })
    },
    modalCancel () {
      this.$refs['addForm'].resetFields()
      this.$nextTick(() => {
        this.modalValue = false
      })
    }
  },
  computed: {
    modalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      if (val && this.isEdit) {
        this.getDetail()
      }
    }
  },
}
</script>
